import { render } from "./VmsSidebarCamerasTabList.vue?vue&type=template&id=843a1ece&ts=true"
import script from "./VmsSidebarCamerasTabList.vue?vue&type=script&lang=ts"
export * from "./VmsSidebarCamerasTabList.vue?vue&type=script&lang=ts"

import "./VmsSidebarCamerasTabList.vue?vue&type=style&index=0&id=843a1ece&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__